import {
    TenderContractsAllComponent,
    TenderContractsAwaitingBidsComponent,
    TenderContractsAwaitingReviewComponent, TenderContractsCancelledComponent
} from '../../../../../../pages';
import {
    TenderBidsResolver,
    TenderContractBidsAnalysisResolver,
    TenderContractsAwaitingBidsResolver, TenderContractsCancelledResolver
} from '../../../../../resolvers';
import { Route } from '@angular/router';

export const contractsCancelledRoute: Route = {
    path: 'cancelled',
    component: TenderContractsCancelledComponent,
    resolve: {
        contracts: TenderContractsCancelledResolver,
    },
};
